import React from 'react'
import useI18n from '../../../i18n/useI18n'
import { formatDateTime, getStatusColor, getStatusLabelKey } from '../utils'

const LatestStatusChangesCard = ({ items = [], loading, title }) => {
  const { t } = useI18n()

  return (
    <div className="card dashboard-card">
      <div className="header">
        <h2><strong>{title}</strong></h2>
      </div>
      <div className="body">
        {loading && !items.length && <div className="skeleton-table"></div>}
        {!loading && !items.length && (
          <div className="empty-state">{t('DASHBOARD_CARD_EMPTY_STATE')}</div>
        )}
        {items.length > 0 && (
          <div className="table-responsive dashboard-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  {/* <th>{t('DASHBOARD_TABLE_APPLICATION')}</th> */}
                  <th>{t('DASHBOARD_TABLE_NEW_STATUS')}</th>
                  <th>{t('DASHBOARD_TABLE_PREVIOUS_STATUS')}</th>
                  <th>{t('DASHBOARD_TABLE_PROGRAM_UNIVERSITY')}</th>
                  <th>{t('DASHBOARD_TABLE_CHANGED_BY')}</th>
                  <th>{t('DASHBOARD_TABLE_DATE')}</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.id}>
                    {/* <td>{item.applicationId || '-'}</td> */}
                    <td>
                      <span
                        className="status-badge"
                        style={{ backgroundColor: getStatusColor(item.newStatus), color: '#fff' }}
                      >
                        {t(getStatusLabelKey(item.newStatus))}
                      </span>
                    </td>
                    <td>
                      {item.oldStatus
                        ? t(getStatusLabelKey(item.oldStatus))
                        : t('DASHBOARD_TABLE_PREVIOUS_STATUS_EMPTY')}
                    </td>
                    <td>
                      <div className="table-stack">
                        {item.program?.name && <span>{item.program.name}</span>}
                        {item.university?.name && (
                          <small>{item.university.name}</small>
                        )}
                      </div>
                    </td>
                    <td>
                      {item.changedBy
                        ? `${item.changedBy.firstName || ''} ${item.changedBy.lastName || ''}`.trim() ||
                          item.changedBy.email
                        : t('COMMON_NOT_AVAILABLE')}
                    </td>
                    <td>{formatDateTime(item.changedAt || item.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default LatestStatusChangesCard

